import { Component, EventEmitter, Input, Output } from "@angular/core";
import { UserService } from "../../domain/user-service";
import { Logger } from "../../infrastructure/logger";
import { ChannelRepository } from "../../domain/channel-repository";
import { MediaRepository } from "../../domain/media-repository";
import { DragulaService } from "ng2-dragula";
import {
  ExportConfiguration,
  ExportConfigurationHeaderType,
} from "../../domain/export-configuration";
import { ShowRepository } from "../../domain/show-repository";

@Component({
  selector: "icn-export-platforms",
  templateUrl: "./export-platforms.html",
  styleUrls: ["./export-platforms.scss"],
})
export class ExportPlatformsComponent {
  @Input()
  exportConfiguration: ExportConfiguration;

  @Output()
  addedExportConfiguration = new EventEmitter<ExportConfiguration>();

  @Output()
  updatedExportConfiguration = new EventEmitter<ExportConfiguration>();

  addOrEdit: "Add" | "Edit" = "Add";
  platformLanguage = "HE";
  languages = [
    { code: "HE", name: "Hebrew" },
    { code: "EN", name: "English" },
  ];

  availableHeaders: { type: ExportConfigurationHeaderType; value?: any }[];

  constructor(
    private userService: UserService,
    private logger: Logger,
    private channelRepository: ChannelRepository,
    private mediaRepository: MediaRepository,
    private dragulaService: DragulaService,
    private showRepository: ShowRepository,
  ) {}

  ngOnInit() {
    this.dragulaService.createGroup("export-bag", {
      revertOnSpill: true,
      ignoreInputTextSelection: true,
    });

    this.availableHeaders = [
      { type: ExportConfigurationHeaderType.Date },
      { type: ExportConfigurationHeaderType.StartTime },
      { type: ExportConfigurationHeaderType.EndTime },
      { type: ExportConfigurationHeaderType.MediaName },
      { type: ExportConfigurationHeaderType.MediaId },
      { type: ExportConfigurationHeaderType.MediaDescription },
      { type: ExportConfigurationHeaderType.Duration },
      { type: ExportConfigurationHeaderType.ShowName },
    ];

    this.userService.getCurrentUser().metadata.forEach((x) => {
      this.availableHeaders.push({
        type: ExportConfigurationHeaderType.Metadata,
        value: x.name,
      });
    });
  }

  ngOnDestroy() {
    this.dragulaService.destroy("export-bag");
  }

  onPlatformLanguageChanged(val) {
    this.platformLanguage = val;
  }

  formatHeader(header) {
    switch (header.type) {
      case ExportConfigurationHeaderType.EndTime:
        return "End Time";
      case ExportConfigurationHeaderType.MediaDescription:
        return "Media Description";
      case ExportConfigurationHeaderType.MediaId:
        return "Media ID";
      case ExportConfigurationHeaderType.MediaName:
        return "Media Name";
      case ExportConfigurationHeaderType.StartTime:
        return "Start Time";
      case ExportConfigurationHeaderType.Date:
        return "Date";
      case ExportConfigurationHeaderType.Metadata:
        return header.value;
      case ExportConfigurationHeaderType.Duration:
        return "Duration";
      case ExportConfigurationHeaderType.ShowName:
        return "Show Name";
    }
  }

  saveExportConfigurations() {
    if (!this.exportConfiguration) {
      return;
    }

    if (this.exportConfiguration.id > 0) {
      this.showRepository
        .updateExportConfiguration(this.exportConfiguration)
        .then(() => {
          this.updatedExportConfiguration.emit(this.exportConfiguration);
        });
    } else {
      this.showRepository
        .addExportConfiguration(this.exportConfiguration)
        .then((exportConfigurationId) => {
          this.exportConfiguration.id = exportConfigurationId;
          this.addedExportConfiguration.emit(this.exportConfiguration);
        });
    }
  }
}
